import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=0074a62a&scoped=true&"
import script from "./ProjectStatus.vue?vue&type=script&lang=js&"
export * from "./ProjectStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStatus.vue?vue&type=style&index=0&id=0074a62a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074a62a",
  null
  
)

export default component.exports